<template>
  <div class="footer">
    <div class="inner">
      <div class="top">
        <img src="https://www.itcast.cn/subject/pythonzly/images/logofooter.png" title="传智教育">
        <ul>
          <li>
            <span>品牌</span>
            <p>上市公司，教育行业A股IPO第一股<br>17年IT教育经验，大品牌有保障</p>
          </li>
          <li>
            <span>课程</span>
            <p>九大IT热门学科，课堂面授<br>亿元级课研投入，打造品质好课</p>
          </li>
          <li>
            <span>师资</span>
            <p>严选大厂师资，让教研更专业<br>全年无休为学生提供学习服务</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-bot">
      <p>江苏传智播客教育科技股份有限公司 版权所有Copyright 2006-2023&nbsp; All Rights Reserved </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      
    };
  },
  methods: {
    childMethod() {
      this.$parent.itcastClick();
    }
  }
};
</script>

<style lang="scss" scoped>

  .footer{
    background: #02163a;
    padding: 30px 0;
    .inner{width: 1200px;margin: 0 auto;}
    .top{
      overflow: hidden;
      img{margin-top: 17px;float: left;}
      ul{
        width: 930px;
        float: right;
        overflow: hidden;
        li{
          width: 284px;
          height: 113px;
          background: url(https://www.itcast.cn/subject/pythonzly/images/footer_img.png) no-repeat 0;
          margin-right: 25px;
          float: left;
          span{font-size: 22px;color: #fff;font-weight: bold;display: block;padding: 15px 0 0 30px;}
          p{font-size: 14px;color: #bbbbbb;line-height: 16px;padding: 10px 0 0 30px;}
        }
      }
    }
    .footer-bot{
      margin: 15px auto 0;
      width: 1050px;
      text-align: center;
      img{display: none;}
      p{
        display: inline-block;
        font-size: 12px;
        color: #bbbbbb;
        margin-bottom: 5px;
        span{display: none;}
        a{color: #bbb;margin: 0 8px}
      }

    }
  }
</style>
